import React from 'react';

import { SkeletonItem } from 'app/components/DetailsPages/shared/styled';

import {
  HomeBaseDrawerItemContainer,
  HomeBaseDrawerItemPeopleWrapper,
} from '../HomeBaseDrawer/styled';

export default function HomeBaseSkeletonDrawer({ withPeople = true }) {
  return (
    <>
      <SkeletonItem style={{ width: 107, height: 18, alignSelf: 'flex-end' }} />
      {[...Array(40)].map((_, index) => (
        <HomeBaseDrawerItemContainer key={index}>
          <SkeletonItem
            style={{
              width: Math.random() * 100 + 100 + 'px',
              height: '22px',
              borderRadius: '25px',
            }}
            animated
          />
          {withPeople ? (
            <HomeBaseDrawerItemPeopleWrapper>
              <SkeletonItem
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: '100%',
                }}
                animated
              />
              <SkeletonItem
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: '100%',
                }}
                animated
              />
              <SkeletonItem
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: '100%',
                }}
                animated
              />
            </HomeBaseDrawerItemPeopleWrapper>
          ) : null}
        </HomeBaseDrawerItemContainer>
      ))}
    </>
  );
}
